/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmissionRecordStatsResponse
 */
export interface EmissionRecordStatsResponse {
    /**
     * 
     * @type {number}
     * @memberof EmissionRecordStatsResponse
     */
    _new: number;
    /**
     * 
     * @type {number}
     * @memberof EmissionRecordStatsResponse
     */
    lastNDays: number;
    /**
     * 
     * @type {number}
     * @memberof EmissionRecordStatsResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof EmissionRecordStatsResponse
     */
    highestRate: number;
    /**
     * 
     * @type {number}
     * @memberof EmissionRecordStatsResponse
     */
    avgRate: number;
    /**
     * 
     * @type {number}
     * @memberof EmissionRecordStatsResponse
     */
    totalRate: number;
    /**
     * 
     * @type {number}
     * @memberof EmissionRecordStatsResponse
     */
    inProgress: number;
    /**
     * 
     * @type {number}
     * @memberof EmissionRecordStatsResponse
     */
    complete: number;
}

/**
 * Check if a given object implements the EmissionRecordStatsResponse interface.
 */
export function instanceOfEmissionRecordStatsResponse(value: object): value is EmissionRecordStatsResponse {
    if ((!('_new' in (value as Record<string, any>)) && !('new' in (value as Record<string, any>))) || ((value as Record<string, any>)['_new'] === undefined && (value as Record<string, any>)['new'] === undefined)) return false;
    if ((!('lastNDays' in (value as Record<string, any>)) && !('last_n_days' in (value as Record<string, any>))) || ((value as Record<string, any>)['lastNDays'] === undefined && (value as Record<string, any>)['last_n_days'] === undefined)) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if ((!('highestRate' in (value as Record<string, any>)) && !('highest_rate' in (value as Record<string, any>))) || ((value as Record<string, any>)['highestRate'] === undefined && (value as Record<string, any>)['highest_rate'] === undefined)) return false;
    if ((!('avgRate' in (value as Record<string, any>)) && !('avg_rate' in (value as Record<string, any>))) || ((value as Record<string, any>)['avgRate'] === undefined && (value as Record<string, any>)['avg_rate'] === undefined)) return false;
    if ((!('totalRate' in (value as Record<string, any>)) && !('total_rate' in (value as Record<string, any>))) || ((value as Record<string, any>)['totalRate'] === undefined && (value as Record<string, any>)['total_rate'] === undefined)) return false;
    if ((!('inProgress' in (value as Record<string, any>)) && !('in_progress' in (value as Record<string, any>))) || ((value as Record<string, any>)['inProgress'] === undefined && (value as Record<string, any>)['in_progress'] === undefined)) return false;
    if (!('complete' in value) || value['complete'] === undefined) return false;
    return true;
}

export function EmissionRecordStatsResponseFromJSON(json: any): EmissionRecordStatsResponse {
    return EmissionRecordStatsResponseFromJSONTyped(json, false);
}

export function EmissionRecordStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmissionRecordStatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        '_new': json['new'],
        'lastNDays': json['last_n_days'],
        'total': json['total'],
        'highestRate': json['highest_rate'],
        'avgRate': json['avg_rate'],
        'totalRate': json['total_rate'],
        'inProgress': json['in_progress'],
        'complete': json['complete'],
    };
}

export function EmissionRecordStatsResponseToJSON(json: any): EmissionRecordStatsResponse {
    return EmissionRecordStatsResponseToJSONTyped(json, false);
}

export function EmissionRecordStatsResponseToJSONTyped(value?: EmissionRecordStatsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'new': value['_new'],
        'last_n_days': value['lastNDays'],
        'total': value['total'],
        'highest_rate': value['highestRate'],
        'avg_rate': value['avgRate'],
        'total_rate': value['totalRate'],
        'in_progress': value['inProgress'],
        'complete': value['complete'],
    };
}

